import PageContainer from '@/common/components/PageContainer'
import { useDateFilter } from '@/common/hooks/useDateFilter'
import { useTablePagination } from '@/common/hooks/useTablePaginate'
import useQueryGetBannedPlayer from '@/modules/manage-player/api/hooks/useQueryGetBannedPlayer'
import BannedPlayerListing from '@/modules/manage-player/components/BannedPlayer/components/BannedPlayerListing'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'

function BannedPlayerPage() {
	const { pageSize, currentPage, searchQuery, channelFilter } =
		useTablePagination()
	const { dateFilter } = useDateFilter()

	const payload = {
		take: pageSize,
		skip: (currentPage - 1) * pageSize,
		username: searchQuery,
		channelName: channelFilter || undefined,
		startDate: dateFilter.startDate,
		endDate: dateFilter.endDate,
	}

	const { data, isLoading } = useQueryGetBannedPlayer(payload)

	return (
		<PageContainer>
			<BannedPlayerListing
				data={data?.data || []}
				total={data?.total || 0}
				isLoading={isLoading}
			/>
		</PageContainer>
	)
}

const GuardedBannedPlayerPage = withUserPermission(BannedPlayerPage, {
	permissionType: PermissionType.Read,
	permissionKey: [PermissionKeys.MANAGE_PLAYER],
})

export default GuardedBannedPlayerPage
